import * as THREE from 'three';



function generateRayTexture() {

    const canvas = document.createElement( 'canvas' );
    canvas.width = 64;
    canvas.height = 64;

    const ctx = canvas.getContext( '2d' );

    const gradient = ctx.createLinearGradient( 0, 0, 64, 0 );
    gradient.addColorStop( 0, 'black' );
    gradient.addColorStop( 1, 'white' );

    ctx.fillStyle = gradient;
    ctx.fillRect( 0, 0, 64, 64 );

    return canvas;

}

// Generate the texture of the point helper sprite

function generatePointerTexture(color) {

    const canvas = document.createElement( 'canvas' );
    canvas.width = 64;
    canvas.height = 64;

    const ctx = canvas.getContext( '2d' );

    ctx.beginPath();
    ctx.arc( 32, 32, 29, 0, 2 * Math.PI );
    ctx.lineWidth = 5;
    ctx.stroke();
    ctx.fillStyle = color || 'white';
    ctx.fill();

    return canvas;

}


export default class VRControllerManager {
    constructor(renderer, controller, controllerGrip) {
        this.controller = controller;
        this.controllerGrip = controllerGrip;

        // MARK: Line
        const material = new THREE.MeshBasicMaterial( {
            color: 0xffffff,
            alphaMap: new THREE.CanvasTexture( generateRayTexture() ),
            transparent: true
        } );

        const geometry = new THREE.BoxGeometry( 0.004, 0.004, 0.35 );

        geometry.translate( 0, 0, -0.15 );

        const uvAttribute = geometry.attributes.uv;

        for ( let i = 0; i < uvAttribute.count; i++ ) {

            let u = uvAttribute.getX( i );
            let v = uvAttribute.getY( i );

            [ u, v ] = ( () => {

                switch ( i ) {

                    case 0 :
                        return [ 1, 1 ];
                    case 1 :
                        return [ 0, 0 ];
                    case 2 :
                        return [ 1, 1 ];
                    case 3 :
                        return [ 0, 0 ];
                    case 4 :
                        return [ 0, 0 ];
                    case 5 :
                        return [ 1, 1 ];
                    case 6 :
                        return [ 0, 0 ];
                    case 7 :
                        return [ 1, 1 ];
                    case 8 :
                        return [ 0, 0 ];
                    case 9 :
                        return [ 0, 0 ];
                    case 10 :
                        return [ 1, 1 ];
                    case 11 :
                        return [ 1, 1 ];
                    case 12 :
                        return [ 1, 1 ];
                    case 13 :
                        return [ 1, 1 ];
                    case 14 :
                        return [ 0, 0 ];
                    case 15 :
                        return [ 0, 0 ];
                    default :
                        return [ 0, 0 ];

                }

            } )();

            uvAttribute.setXY( i, u, v );

        }

        const linesHelper = new THREE.Mesh( geometry, material );
        linesHelper.renderOrder = Infinity;

        // MARK: Pointer
        const spriteMaterial = new THREE.SpriteMaterial( {
            map: new THREE.CanvasTexture( generatePointerTexture() ),
            sizeAttenuation: false,
            depthTest: false
        } );

        const pointer = new THREE.Sprite( spriteMaterial );

        pointer.scale.set( 0.015, 0.015, 1 );
        pointer.renderOrder = Infinity;

        // MARK: Add to controller

        this.ray = linesHelper.clone();
        this.point = pointer.clone();

        this.controller.add( this.ray, this.point );
        this.ray.visible = false;
        this.point.visible = false;
        this.controller.ray = this.ray;
        this.controller.point = this.point;



    }

    setFromController(ray) {
        const dummyMatrix = new THREE.Matrix4();
        dummyMatrix.identity().extractRotation( this.controller.matrixWorld );

        ray.origin.setFromMatrixPosition( this.controller.matrixWorld );
        ray.direction.set( 0, 0, -1 ).applyMatrix4( dummyMatrix );

    }

    setPointerAt(vec) {
        const localVec = this.controller.worldToLocal( vec );
        this.controller.point.position.copy( localVec );
    }

    makeRayVisible() {
        this.ray.visible = true;
        this.point.visible = true;

        // make brush invisible when doing questionnaire
        if (this.controller.brush) {
            this.controller.brush.visible = false;
        }
    }

    makeRayInvisible() {
        this.ray.visible = false;
        this.point.visible = false;

        // make brush visible
        if (this.controller.brush) {
            this.controller.brush.visible = true;
        }
    }

    drawBrush(position) {
        const spriteMaterial = new THREE.SpriteMaterial( {
            map: new THREE.CanvasTexture( generatePointerTexture('#000000') ),
            sizeAttenuation: false,
            depthTest: false
        } );

        const pointer = new THREE.Sprite( spriteMaterial );

        pointer.scale.set( 0.01, 0.01, 1.2 );

        const brush = pointer.clone();

        this.controller.add( brush );
        this.controller.brush = brush;

        // const localPos = this.controller.worldToLocal( position );
        this.controller.brush.position.copy( position );

        const lineMaterial = new THREE.LineBasicMaterial({
            color: '#8270bd',
            linewidth: 5,
        });

        // Create a line geometry
        const lineGeometry = new THREE.BufferGeometry().setFromPoints([
            new THREE.Vector3(0, 0, -0.02), // Start point (controller position)
            position // End point (brush position)
        ]);

        // Create a line
        const line = new THREE.Line(lineGeometry, lineMaterial);

        // Add the line to the controller
        this.controller.add(line);
    }

    getBrush() {
        return this.controller.brush;
    }

}